import { render, staticRenderFns } from "./answerViewer.vue?vue&type=template&id=5fb8729c&scoped=true&"
import script from "./answerViewer.vue?vue&type=script&lang=js&"
export * from "./answerViewer.vue?vue&type=script&lang=js&"
import style0 from "./answerViewer.vue?vue&type=style&index=0&id=5fb8729c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb8729c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb8729c')) {
      api.createRecord('5fb8729c', component.options)
    } else {
      api.reload('5fb8729c', component.options)
    }
    module.hot.accept("./answerViewer.vue?vue&type=template&id=5fb8729c&scoped=true&", function () {
      api.rerender('5fb8729c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/answerViewer.vue"
export default component.exports